module.exports = __webpack_public_path__ + "images/emoji/clock8.ed07dc0ebe5f98855150.png";